import { useQuery } from 'react-query'
import { baseURL } from '../../../services/api'
import { HeadingPages } from '../../../components/HeadingPages'
import Header from '../../../components/Header'
import { Box, Button, Flex, Input, Select, Text } from '@chakra-ui/react'
import { Card } from './Card'
import { useEffect, useState } from 'react'
import { firstLetterUpperCaseAndRestLowerCase } from '../../../utils/capitalFirstLetter'
import { Loader } from '../../../components/ComponentLoader/Loader'

const getVendedores = async () => {
  const response = await baseURL.get('editar-pedido/listar-vendedores')

  const data = response.data.map((item) => {
    return {
      value: item.codvend,
      label: firstLetterUpperCaseAndRestLowerCase(item.apelido),
    }
  })

  return data
}

const getFluxoRodizio = async () => {
  const response = await baseURL.get('crm-controle/listar-fluxo-rodizio/')
  return response.data
}

export function RodizioDeVendas() {
  const [filterData, setFilterData] = useState([])
  const [originalData, setOriginalData] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [counter, setCounter] = useState(0)

  async function getDataRodizio() {
    setIsLoading(true)
    const response = await baseURL.get('crm-controle/listar-fluxo-rodizio/')

    const pedidosHoje = response.data.filter((item) => {
      const data = new Date(item.data_controle)
      const dataHoje = new Date()

      return (
        data.getDate() === dataHoje.getDate() &&
        data.getMonth() === dataHoje.getMonth() &&
        data.getFullYear() === dataHoje.getFullYear()
      )
    })

    //pega todos os items que tem a variavel data_controle
    const counterByDataControle = pedidosHoje.filter(
      (item) => item.data_controle !== ""
    )

    setCounter(counterByDataControle.length)
    setFilterData(pedidosHoje)
    setOriginalData(response.data)

    setIsLoading(false)
  }

  useEffect(() => {
    getDataRodizio()
  }, [])

  const { data: dataVendedores } = useQuery(
    ['listarVendedores', 'editar-pedido/listar-vendedores'],
    getVendedores,
    {
      staleTime: 60 * 60 * 1000 * 24, // 24 hours
      refetchOnWindowFocus: false,
    }
  )

  const [filterProps, setFilterProps] = useState(null)

  function handleInputValue(event) {
    const { name, value } = event.target

    setFilterProps({ ...filterProps, [name]: value })
  }

  function filterDataFluxoRodizio() {
    const { dataDe, dataAte, vendedor } = filterProps

    let filtered = [...originalData]

    if (vendedor) {
      filtered = filtered.filter((item) => item.codigo_vendedor === vendedor)
    }

    if (dataDe && dataAte) {
      filtered = filtered.filter((item) => {
        const data = new Date(item.data_entrada)
        const dataDeFormatada = new Date(dataDe)
        const dataAteFormatada = new Date(dataAte)
        dataAteFormatada.setDate(dataAteFormatada.getDate() + 1) // Adicione um dia

        return data >= dataDeFormatada && data < dataAteFormatada // Use < em vez de <= para não incluir o final do dia
      })
    }
    if (dataDe && dataAte && vendedor) {
      filtered = filtered.filter((item) => {
        const data = new Date(item.data_entrada)
        const dataDeFormatada = new Date(dataDe)
        const dataAteFormatada = new Date(dataAte)
        dataAteFormatada.setDate(dataAteFormatada.getDate() + 1) // Adicione um dia

        return (
          data >= dataDeFormatada &&
          data < dataAteFormatada &&
          item.codigo_vendedor === vendedor
        ) // Use < em vez de <= para não incluir o final do dia
      })
    }

    setFilterData(filtered)
  }

  return (
    <>
      <HeadingPages name="Rodizio de Vendas" />
      <Box maxW="1200px" w="100%" mx="auto">
        
        <Box p="4" display="flex" justifyContent="space-between">
          
          <Flex alignItems="center" gap={2}>
            <Text>De</Text>
            <Input
              type="date"
              name="dataDe"
              onChange={handleInputValue}
              maxW="300px"
            />
          </Flex>
          <Flex alignItems="center" gap={2}>
            <Text>Até</Text>
            <Input type="date" name="dataAte" onChange={handleInputValue} />
          </Flex>
          <Select
            placeholder="Selecione o vendedor"
            w="300px"
            onChange={handleInputValue}
            name="vendedor"
          >
            {dataVendedores?.map((item, index) => (
              <option key={index} value={item.value}>
                {item.label}
              </option>
            ))}
          </Select>

          <Button colorScheme="blue" onClick={filterDataFluxoRodizio}>
            Filtrar
          </Button>
        </Box>

        <Text textAlign="center" fontSize="1.2rem" fontWeight="bold" color="gray.600">
          Existem {counter} chamados na tela
        </Text>


        {isLoading && (
          <Loader
            img={
              'https://imgproductioncrm.s3.us-east-2.amazonaws.com/loading-verde.gif'
            }
          />
        )}

        <Box
          p="4"
          display="grid"
          gridTemplateColumns="repeat(auto-fit, minmax(300px, 1fr))"
          gap={2}
        >
          {filterData?.map((item, index) => (
            <Card key={index} item={item} />
          ))}
        </Box>
      </Box>
    </>
  )
}
